import { render } from "./BasicRow.vue?vue&type=template&id=52b3d25c&scoped=true"
import script from "./BasicRow.vue?vue&type=script&lang=js"
export * from "./BasicRow.vue?vue&type=script&lang=js"

import "./BasicRow.vue?vue&type=style&index=0&id=52b3d25c&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b3d25c"]])

export default __exports__